module.exports = mycorvinus_shared;